import { IButtonProps } from '../Button';

export interface ICheckboxProps extends IButtonProps {
  checked: boolean;
  id: string;
  value?: string;
  name: string;
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  checkecBoxes?: any;
  onChange: (value: any) => void;
}

export const Checkbox: React.FC<ICheckboxProps> = ({
  className,
  children,
  checked,
  onChange,
  id,
  name,
  checkecBoxes,
  labelClassName,
  inputClassName,
  disabled = false,
  ...props
}) => {
  return (
    <div className={`mx-auto xl:ml-0 flex items-center ${className}`}>
      <input
        value=""
        type="checkbox"
        name={name}
        checked={checked}
        id={id}
        disabled={disabled}
        onChange={onChange}
        className={
          inputClassName ||
          `h-min min-w-[16px] min-h-[16px] focus:ring-0 focus:shadow-none rounded text-tt-yellow accent-tt-yellow`
        }
      />
      {/* The label's tap area reaches 44px tall without moving anything
          (Apple HIG); the box itself is 16px (WHIT-494). The keyboard focus
          ring comes from globals.css. */}
      <label
        className={`relative ml-2 before:absolute before:-inset-x-7 before:-inset-y-2.5 before:content-[''] ${labelClassName}`}
        htmlFor={id}>
        {children}
      </label>
      {/* <input
        className="form-check-input focus:ring-0 focus:shadow-none focus:outline-hidden appearance-none h-4 w-4 border border-gray-300 rounded-xs bg-white checked:bg-tt-yellow checked:border-tt-yellow transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
        type="checkbox"
        checked={checked}
        onChange={() => onChange(!checked)}
      /> */}
      {/* <H5 className="pl-2">{children}</H5> */}
    </div>
  );
};
